import { CommonGet, CommonPost } from '../../helpers/HttpClient';

export default {
  getFactoryrequestDetails,
  getfactoriesForDropDown,
  getGroupsForDropdown,
  getFactoryItemsByFactoryID,
  getRequestsByFactoryItemIDANDRouteID,
  getRoutesForDropDown,
  getRegistrationNumbersForDropDown,
  getAvailableGrnByFactoryItem,
  getGRNListByFactoryItem,
  GetFactoryItemRequestDetails,
  ApproveFactoryItems,
  rejectFactoryItems,
  GetFactoryItemGRNListByFactoryItemIDAndSupplierID,
};

async function getAvailableGrnByFactoryItem(factoryItem) {
  var grnArray = [];

  const response = await CommonGet('/api/FactoryAdjustment/GetAvailableGrnByFactoryItem', 'factoryItem=' + factoryItem)
  for (let item of Object.entries(response.data)) {
    grnArray[item[1]["factoryItemGRNID"]] = item[1]["grnNumber"]
  }
  return grnArray;
}

async function getRegistrationNumbersForDropDown(customerID) {
  const response = await CommonGet('/api/Customer/GetRegistrationNumbersByCustomerID', 'customerID=' + customerID)
  return response.data;
}

async function getRoutesForDropDown(factoryID) {
  var routeArray = [];

  const response = await CommonGet('/api/Group/GetRouteByFactoryID', 'factoryID=' + factoryID)
  for (let item of Object.entries(response.data)) {
    routeArray[item[1]["routeID"]] = item[1]["routeName"]
  }
  return routeArray;
}

async function getFactoryItemsByFactoryID(factoryID) {
  var factoryItemArray = [];
  const response = await CommonGet('/api/FactoryAdjustment/GetFactoryItemsByFactoryID', "factoryID=" + parseInt(factoryID));
  if (response.data != null) {
    for (let item of Object.entries(response.data)) {
      factoryItemArray[item[1]["factoryItemID"]] = item[1]["itemName"]
    }
    return factoryItemArray;
  } else {
    return;
  }
}

async function getfactoriesForDropDown(groupID) {
  var factoryArray = [];
  
  const response = await CommonGet('/api/Group/GetFactoryByGroupID', 'groupID=' + groupID)
  for (let item of Object.entries(response.data)) {
    factoryArray[item[1]["factoryID"]] = item[1]["factoryName"]
  }
  return factoryArray;
}

async function getGroupsForDropdown() {
  var groupArray = [];
  const response = await CommonGet('/api/Group/GetAllGroups', null)
  for (let item of Object.entries(response.data)) {
    if (item[1]["isActive"] === true) {
      groupArray[item[1]["groupID"]] = item[1]["groupName"]
    }
  }
  return groupArray;
}

async function getGRNListByFactoryItem(factoryItem) {
  const response = await CommonGet('/api/FactoryItemGrn/GetGRNListByFactoryItem', 'factoryItem=' + factoryItem);
  return response.data;
}

async function getRequestsByFactoryItemIDANDRouteID(factoryItemID, routeID) {
  const response = await CommonGet('/api/FactoryItemRequest/GetRequestsByFactoryItemIDANDRouteID', "factoryItemID=" + parseInt(factoryItemID) + "&routeID=" + parseInt(routeID));
  return response.data;
}

async function getFactoryrequestDetails(factoryItemRequestID) {
  const response = await CommonGet('/api/FactoryItemRequest/GetFactoryItemRequestDetails', "factoryItemRequestID=" + parseInt(factoryItemRequestID));
  return response.data; 
}


async function GetFactoryItemRequestDetails(factoryItemRequestInputModel) {
  let response = await CommonPost('/api/ApproveFactoryItemIssue/GetFactoryItemRequestGatePassDetails', null, factoryItemRequestInputModel);
  return response;
}

async function ApproveFactoryItems(factoryItemApproveModel) {
  let response = await CommonPost('/api/ApproveFactoryItemIssue/FactoryItemApproval', null, factoryItemApproveModel);
  return response;
}

async function rejectFactoryItems(rejectFactoryItemApproveModel) {
  let response = await CommonPost('/api/ApproveFactoryItemIssue/FactoryItemReject', null, rejectFactoryItemApproveModel);
  return response;
}

async function GetFactoryItemGRNListByFactoryItemIDAndSupplierID(factoryItemID,supplierID) {
  const response = await CommonGet('/api/FactoryItemGrn/GetGRNListByFactoryItemIDandSupplierID', "factoryItemID=" + parseInt(factoryItemID) + "&supplierID=" + parseInt(supplierID));
  return response.data;
}


